import { defineMessages } from "react-intl";

const PREFIX = "ExportSubscribeButton";
export const messages = defineMessages({
  subscribeButton: {
    id: `${PREFIX}.subscribeButton`,
    defaultMessage: "Subscribe",
  },
});
